import cookie from 'js-cookie';
import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Menu, Dropdown, Avatar } from 'antd';
import { Link, withRouter } from 'react-router-dom';

import { logout } from '../../features/login/actions';
import { IconUser, IconDropDown } from '../../assets/index';
import { isAuthenticate, isEmpty } from '../../utils/helpers/helpers';
import { routes, routePage, TOKEN } from '../../utils/constants/constant';

import LoginModal from '../../features/login/LoginModal';
import RegisterModal from '../../features/login/RegisterModal';
import ForgotPasswordModal from '../../features/login/ForgotPasswordModal';

import './Header.scss';
import clsx from 'clsx';
import * as actionTypes from '../../../src/utils/constants/actionTypes';
const listMenu = [
  {
    id: 0,
    name: 'Trang chủ',
    isAuth: false,
    routes: routes.HOME,
  },
  // {
  //   id: 1,
  //   name: "Công cụ",
  //   isAuth: false,
  //   routes: routes.TOOLS,
  // },
  {
    id: 2,
    name: 'Hỗ Trợ',
    isAuth: false,
    routes: routePage.HELP.FAQS_HELP,
  },
  // {
  //   id: 3,
  //   name: "Liên hệ với chúng tôi",
  //   isAuth: false,
  //   routes: routes.CONTACT_US,
  // },
  {
    id: 4,
    name: 'Tổng quan',
    isAuth: true,
    routes: routes.DASHBOARD,
  },
  // {
  //   id: 5,
  //   name: "Quảng cáo của tôi",
  //   isAuth: true,
  //   routes: routePage.MY_ADS.LIST_MY_ADS,
  // },
  // {
  //   id: 6,
  //   name: "Hiệu suất",
  //   isAuth: true,
  //   routes: routePage.PERFORMANCE.OVERVIEW_PERFORMANCE,
  // },
  {
    id: 7,
    name: 'Tài khoản của tôi',
    isAuth: true,
    routes: routes.MY_ACCOUNT,
  },
  {
    id: 8,
    name: 'Hỗ trợ',
    isAuth: true,
    routes: routePage.HELP.FAQS_HELP,
  },
];

const listModalType = {
  LOGIN_MODAL: 'LOGIN_MODAL',
  REGISTER_MODAL: 'REGISTER_MODAL',
  FORGOT_PASSWORD_MODAL: 'FORGOT_PASSWORD_MODAL',
};
const Header = (props) => {
  const [visibleModalType, setVisibleModalType] = useState('');
  const dispatch = useDispatch();
  const handleVisible = (type = '') => {
    setVisibleModalType(type);
  };

  const menu = (
    <Menu className='dropdown-account1'>
      <Menu.Item onClick={() => handleVisible(listModalType.LOGIN_MODAL)}>
        Đăng nhập
      </Menu.Item>
      <Menu.Item onClick={() => handleVisible(listModalType.REGISTER_MODAL)}>
        Đăng ký
      </Menu.Item>
    </Menu>
  );

  const handleLogout = async () => {
    try {
      const { data } = await logout();
      if (data.code === 200) {
        cookie.remove(TOKEN);
        props.history.push(routes.HOME);
        dispatch({
          type: actionTypes.FETCHING_PROFILE_SUCCESS,
          payload: {},
        });
      }
    } catch (error) {}
  };

  const menuUser = (
    <Menu className='dropdown-account'>
      <Menu.Item onClick={handleLogout}>Đăng xuất</Menu.Item>
    </Menu>
  );
  const profile = props?.profile || {};
  const userInfo = !isEmpty(profile?.userInfo) ? profile?.userInfo : {};
  const lastName = userInfo?.name?.split(' ')?.pop() || '';

  const checkSelectedMenu = (r) => {
    return (
      props?.location?.pathname === r || props?.location?.pathname === r + '/'
    );
  };

  return (
    <div className='wp-header'>
      <div className='content-header'>
        <div className='item-header'>
          <div className='img-web-box'>
            <img
              src='https://storage.googleapis.com/tripi-assets/mytour/icons/icon_logo_mytour_red.svg'
              alt='img_logo'
              className='logo-mytour'
              onClick={() => props.history.push(routes.DASHBOARD)}
            />
            <div className='dived' />
            <span className='title-web'>Đối tác</span>
          </div>
          {listMenu.map((el, index) => {
            if (isAuthenticate() && el.isAuth) {
              return (
                <div
                  className={clsx('item-menu', {
                    'route-selected': checkSelectedMenu(el?.routes),
                  })}
                  key={index}
                >
                  <Link to={el.routes} className={`btn4`}>
                    {el.name}
                  </Link>
                </div>
              );
            } else if (!(isAuthenticate() || el.isAuth)) {
              return (
                <div className='item-menu' key={index}>
                  <Link
                    to={el.routes}
                    className={`btn4 ${
                      checkSelectedMenu(el?.routes) && 'route-selected'
                    }`}
                  >
                    {el.name}
                  </Link>
                </div>
              );
            }
            return null;
          })}
        </div>
        <div className='item-header'>
          {!isAuthenticate() ? (
            <Dropdown overlay={menu} placement='bottomRight' arrow>
              <div
                className='ant-dropdown-link'
                onClick={(e) => e.preventDefault()}
              >
                <IconUser />
                <IconDropDown />
              </div>
            </Dropdown>
          ) : (
            <Dropdown overlay={menuUser} placement='bottomRight' arrow>
              <div
                className='ant-dropdown-link dropdown-user-login'
                onClick={(e) => e.preventDefault()}
              >
                {!isEmpty(userInfo?.image) && (
                  <Avatar src={userInfo?.image} className='avatar-user' />
                )}
                <span className='name-user'>{lastName || ''}</span>
                <IconDropDown />
              </div>
            </Dropdown>
          )}
        </div>
      </div>
      <LoginModal
        visible={visibleModalType === listModalType.LOGIN_MODAL}
        handleVisible={handleVisible}
      />
      <RegisterModal
        visible={visibleModalType === listModalType.REGISTER_MODAL}
        handleVisible={handleVisible}
      />
      <ForgotPasswordModal
        visible={visibleModalType === listModalType.FORGOT_PASSWORD_MODAL}
        handleVisible={handleVisible}
      />
    </div>
  );
};

export default connect(
  (state) => ({
    profile: state.systemReducer.profile,
  }),
  {}
)(withRouter(Header));
